const NumberFormat = {
  NUMBER_FORMAT_DIGITS: 3,
};
export default NumberFormat;
